@if (contacts(); as c) {
  <section
    class="cabinet-help-contacts"
    [attr.aria-labelledby]="hideSectionTitle() ? null : 'cabinet-help-contacts-heading'"
  >
    @if (!hideSectionTitle()) {
      <h2 id="cabinet-help-contacts-heading" class="cabinet-help-contacts__section-title">
        {{ 'CLIENT.CABINET.HELP.CONTACTS_TITLE' | translate }}
      </h2>
    }

    <div class="cabinet-help-contacts__grid">
      @if (!hidePrimaryContacts()) {
        <div class="cabinet-help-contacts__item">
          <span class="cabinet-help-contacts__label">{{
            'CLIENT.CABINET.HELP.QUICK_CALL_LABEL' | translate
          }}</span>
          <a class="cabinet-help-contacts__value" [href]="telHref(c.phone)">{{ c.phone }}</a>
        </div>

        <div class="cabinet-help-contacts__item">
          <span class="cabinet-help-contacts__label">{{
            'CLIENT.CABINET.HELP.CONTACTS_EMAIL_LABEL' | translate
          }}</span>
          <a class="cabinet-help-contacts__value" [href]="'mailto:' + c.email">{{ c.email }}</a>
        </div>
      }

      <div class="cabinet-help-contacts__item">
        <span class="cabinet-help-contacts__label">{{
          'CLIENT.CABINET.HELP.WEBSITE_LABEL' | translate
        }}</span>
        <a
          class="cabinet-help-contacts__value"
          [href]="c.website"
          (click)="openHttpUrl(c.website, $event)"
          >{{ c.website }}</a
        >
      </div>

      @if (workScheduleText()) {
        <div class="cabinet-help-contacts__item cabinet-help-contacts__item--wide">
          <span class="cabinet-help-contacts__label">{{
            'CLIENT.CABINET.HELP.WORK_SCHEDULE_TITLE' | translate
          }}</span>
          <span class="cabinet-help-contacts__value cabinet-help-contacts__value--plain">
            {{ c.work.timezone }} · {{ workScheduleText() }}
          </span>
        </div>
      }
    </div>

    @if (messengers().length) {
      <div class="cabinet-help-contacts__channels">
        <span class="cabinet-help-contacts__label">{{
          'CLIENT.CABINET.HELP.MESSENGERS_TITLE' | translate
        }}</span>
        <div class="cabinet-help-contacts__chips">
          @for (m of messengers(); track m.id) {
            <a
              class="cabinet-help-contacts__chip"
              [href]="m.link"
              (click)="openHttpUrl(m.link, $event)"
              >{{ m.name }}</a
            >
          }
        </div>
      </div>
    }

    @if (socials().length) {
      <div class="cabinet-help-contacts__channels">
        <span class="cabinet-help-contacts__label">{{
          'CLIENT.CABINET.HELP.SOCIALS_TITLE' | translate
        }}</span>
        <div class="cabinet-help-contacts__chips">
          @for (s of socials(); track s.id) {
            <a
              class="cabinet-help-contacts__chip"
              [href]="s.link"
              (click)="openHttpUrl(s.link, $event)"
              >{{ s.name }}</a
            >
          }
        </div>
      </div>
    }
  </section>
}
